import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-camera-lens-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-semibold">女性ins大片</span>
            </div>
            <p className="text-sm text-background-200/80 leading-relaxed max-w-sm">
              专注展示最新女性 INS 风格大片，涵盖时尚、艺术摄影等视觉内容。帮助摄影爱好者与时尚女性获取拍摄灵感，欣赏高品质女性摄影作品。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-instagram-line", "ri-weibo-line", "ri-wechat-line", "ri-pinterest-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-full border border-background-100/25 flex items-center justify-center cursor-pointer transition-colors hover:bg-primary-500 hover:border-primary-500"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">
              <Link to="/inspiration" className="cursor-pointer hover:text-accent-400 transition-colors">
                作品分类
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">
              <Link to="/about" className="cursor-pointer hover:text-accent-400 transition-colors">
                关于本站
              </Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/inspiration" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  灵感专题
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  搜索作品
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © {year} 女性ins大片 · 保留所有权利 · 本站内容均为虚拟演示
          </p>
          <p className="text-xs text-background-200/70">用影像记录女性的每一种可能</p>
        </div>
      </div>
    </footer>
  );
}